<template>
    <div class="revenue-detail">
        <div v-if="ifPublic" style="height: 56px;line-height: 56px;color:rgba(51, 51, 51, 1);font-size: 18px;font-weight: bold;padding-left:24px;background:#fff;">{{taskName}}</div>
        <div v-if="!ifPublic" style="display:inline-block;width:392px;height:200px;position:absolute;left:50%;margin-left:-196px;top:50%;margin-top:-100px;">
            <div style="color:#000;font-size:20px;text-align:center;">密码访问数据报表</div>
            <a-input v-model="proPwd" style="height:48px;margin:32px 0 16px" placeholder="请输入6位数字密码" />
            <span @click="testPwd" style="background:rgba(24, 144, 255, 1);display:inline-block;width:100%;line-height:48px;border-radius:6px;color:#fff;text-align:center;font-size:14px;cursor: pointer;">验证访问密码</span>
        </div>
        <div v-if="ifPublic"  style="padding:20px 24px;flex:1">
            <div style="background: #fff;border-radius: 4px;height: 100%;position: relative">
                <div style="display: inline-block;width: 630px;height:290px;position: absolute;left:50%;margin-left:-250px;top:50%;margin-top: -200px;">
                    <div style="color:rgba(51, 51, 51, 1);font-size: 20px;font-weight: bold;">{{remark}}</div>
                    <div style="color:rgba(0, 0, 0, 1);font-size: 14px;margin-top:54px;;">任务名称</div>
                    <div style="color:rgba(158, 172, 196, 1);font-size: 14px;">{{taskName}}</div>
                    <div style="color:rgba(0, 0, 0, 1);font-size: 14px;margin-top:24px;">提交时间</div>
                    <div style="color:rgba(158, 172, 196, 1);font-size: 14px;">{{commitTime}}</div>
                    <div style="color:rgba(0, 0, 0, 1);font-size: 14px;margin-top:24px;;">提交号码数量</div>
                    <div style="color:rgba(158, 172, 196, 1);font-size: 14px;">{{commitCount}}</div>

                    <div style="text-align:center;margin-top:50px;">
                        <div v-if="downloadUrl==''">
                            <img style="width:120px;" src="../assets/img/no-calllist.png" alt="">
                        </div>
                        <div v-if="downloadUrl==''&&failCallRecordUrl==''" style="color:rgba(158, 172, 196, 1);font-size:14px;">话单生成中，请稍后...</div>
                        <a v-if="downloadUrl!=''" style="display: inline-block;height:40px;line-height: 40px;text-align: center;background:rgba(24, 144, 255, 1);color:#fff;border-radius: 4px;cursor: pointer;margin-right:12px;padding:0 12px;" :href="downloadUrl" target="_blank">下载成功话单</a>
                        <a v-if="callRecordByDialogueUrl!=''" style="display: inline-block;height:40px;line-height: 40px;text-align: center;background:rgba(24, 144, 255, 1);color:#fff;border-radius: 4px;cursor: pointer;margin-right:12px;padding:0 12px;" :href="callRecordByDialogueUrl" target="_blank">下载成功话单（按对话）</a>
                        <a v-if="failCallRecordUrl!=''" style="display: inline-block;height:40px;line-height: 40px;text-align: center;background:rgba(24, 144, 255, 1);color:#fff;border-radius: 4px;cursor: pointer;margin-right:12px;padding:0 12px;" :href="failCallRecordUrl" target="_blank">下载失败话单</a>
                        <a v-if="failRecordNoSuccessUrl!=''" style="display: inline-block;height:40px;line-height: 40px;text-align: center;background:rgba(24, 144, 255, 1);color:#fff;border-radius: 4px;cursor: pointer;margin-right:12px;padding:0 12px;" :href="failRecordNoSuccessUrl" target="_blank">下载失败话单（无成功）</a>
                </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BillOverview',
        data() {
            return {
                id: '',
                downloadUrl: '',
                failCallRecordUrl: '',
                failRecordNoSuccessUrl: '',
                ifPublic: false,
                proPwd: '',
                commitCount: '',
                commitTime: '',
                taskName: '',
                remark: '',
                callRecordByDialogueUrl: ''
            }   
        },
        methods: {
            queryData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/waitingCall/external/downloadUrl', 
                        params: {
                            id: this.id,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.downloadUrl = response.data.data.callRecordUrl
                        this.failCallRecordUrl = response.data.data.failCallRecordUrl
                        this.failRecordNoSuccessUrl = response.data.data.failRecordNoSuccessUrl
                        this.commitCount = response.data.data.commitCount
                        this.commitTime = response.data.data.commitTime
                        this.taskName = response.data.data.taskName
                        this.remark = response.data.data.remark
                        this.callRecordByDialogueUrl = response.data.data.callRecordByDialogueUrl
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            viewSuccessBillDetail() {
                window.open(this.downloadUrl, '_blank');
            },
            viewFailBillDetail() {
                window.open(this.failCallRecordUrl, '_blank');
            },
            testPwd() {
                this.axios.post('/api/waitingCall/external/download/valid', {
                    id: this.id,
                    password: this.proPwd
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.ifPublic = true
                        this.queryData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryShareType() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/waitingCall/external/download/shareType', 
                        params: {
                            id: this.id,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        if(response.data.data.type == 1){
                            this.ifPublic = true
                            this.queryData()
                            
                        }else{
                            this.ifPublic = false
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
        },
        mounted: function() {
            this.id = this.$route.query.id
            this.queryShareType()
        },

    }
</script>

<style scoped lang="less">
    .revenue-detail{
        height: 100%;
        background: rgba(240, 242, 243, 1);
        display: flex;
        flex-direction: column;
    }
</style>